import { ValidateJSModel, LocationModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModel from '../location';

interface LocationUSAddressModel {
  street: LocationModel['street']
  city: LocationModel['city']
  state: LocationModel['state']
  zipcode: LocationModel['zipcode']
}

const locationUSAddressNoCountryModelValidator: ValidateJSModel<LocationUSAddressModel> = {
  street: locationModel.street as ValidateJSModelAttribute<LocationUSAddressModel, 'street'>,
  city: locationModel.city as ValidateJSModelAttribute<LocationUSAddressModel, 'city'>,
  state: locationModel.state as ValidateJSModelAttribute<LocationUSAddressModel, 'state'>,
  zipcode: locationModel.zipcode as ValidateJSModelAttribute<LocationUSAddressModel, 'zipcode'>,

};

export default locationUSAddressNoCountryModelValidator;
